import React, { useState } from 'react';
import { Alert, Button, DatePicker, Form, Modal, Space, Typography, message } from 'antd';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import { darDeBajaEmpleado } from '../../api/empleadosApi';
import { errorEmpleado } from './errores';
import type { ErrorEmpleado } from './errores';

const { Paragraph } = Typography;

interface Props {
  abierto: boolean;
  idEmpleado: number;
  nombre: string;
  onCerrar: () => void;
  onGuardado: () => void;
}

/** Confirmación de la baja lógica, con su fecha (por defecto, hoy). Cierra la delegación y la zona vigentes. */
export const BajaModal: React.FC<Props> = ({ abierto, idEmpleado, nombre, onCerrar, onGuardado }) => (
  <Modal open={abierto} onCancel={onCerrar} title="Dar de baja" footer={null} destroyOnClose maskClosable={false}>
    {abierto && <Contenido idEmpleado={idEmpleado} nombre={nombre} onCerrar={onCerrar} onGuardado={onGuardado} />}
  </Modal>
);

const Contenido: React.FC<Omit<Props, 'abierto'>> = ({ idEmpleado, nombre, onCerrar, onGuardado }) => {
  const [fecha, setFecha] = useState<Dayjs | null>(dayjs());
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState<ErrorEmpleado | null>(null);

  const confirmar = async () => {
    if (!fecha) return;
    setGuardando(true);
    setError(null);
    try {
      await darDeBajaEmpleado(idEmpleado, fecha.format('YYYY-MM-DD'));
      message.success('Baja registrada.');
      onGuardado();
      onCerrar();
    } catch (e) {
      setError(errorEmpleado(e));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <>
      <Paragraph>
        Vas a dar de baja a <b>{nombre}</b>. Dejará de aparecer entre los empleados activos y se cerrarán su delegación y su zona vigentes.
      </Paragraph>
      <Form layout="vertical">
        <Form.Item label="Fecha de baja" htmlFor="empleado-fecha-baja" required validateStatus={fecha ? undefined : 'error'} help={fecha ? undefined : 'La fecha de baja es obligatoria.'}>
          <DatePicker id="empleado-fecha-baja" format="DD/MM/YYYY" value={fecha} onChange={setFecha} allowClear={false} style={{ width: '100%' }} />
        </Form.Item>
      </Form>
      {error && <Alert type="error" showIcon message={error.mensaje} style={{ marginBottom: 16 }} />}
      <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onCerrar}>Cancelar</Button>
        <Button danger loading={guardando} disabled={!fecha} onClick={confirmar}>Confirmar baja</Button>
      </Space>
    </>
  );
};
